  import React from 'react';

  export default function PaimentCardForm({
    color,
    icon,
    somme,
    explain,
    onClick,
  }) {
    return (
      <div
        className="w-100 w-md-25"
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      >
        <div className="card border-0">
         <div
     className={`card-body text-white d-flex align-items-center gap-3 flex-column flex-md-row text-center text-md-end justify-content-center justify-content-md-between`}
            style={{
              backgroundColor: color,
              fontFamily: 'Montserrat',
              borderRadius: '5.41px',
            }}
          >
            <div className=" d-flex">
              <div
                className={`d-flex align-items-center justify-content-center`}
                style={{ width: '40px', height: '40px' }}
              >
                <span className="fs-4 text-white">{icon}</span>
              </div>
            </div>
            <div className="explain d-flex flex-column">
              <span className="fw-bold">{somme}</span>
              {/* <span className="fw-bold">22000</span> */}
              <span className="fw-bold">FCFA</span>
              <span style={{ fontSize: '13px' }}>{explain}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
